module.exports = __webpack_public_path__ + "static/media/webinars.d7242e00.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/sidebar/webinars.svg
// module id = 1037
// module chunks = 0